package features.userAuthentication.internal

import kangaroorewards.appsdk.core.network.base.Endpoint

internal val UserAuthenticationEndpoint = Endpoint(path = "oauth/token")